import styled from 'styled-components';

export const ModalCardTitle = styled.div`
  font-family: Calibre-Semibold, sans-serif;
  font-size: 20px;
  color: rgb(26, 23, 28);
`;

export const ModalHeaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

export const ModalFooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ConfirmModalBody = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-family: Calibre-Regular, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  color: rgb(26, 23, 28);
`;

export const ConfirmModalBodyStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BulkDeleteConfirmHelper = styled.p`
  margin: 0;
  font-family: Calibre-Regular, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: rgb(100, 100, 100);
`;

export const BulkDeleteConfirmList = styled.ul`
  margin: 0;
  padding-left: 20px;
  max-height: 280px;
  overflow-y: auto;
`;

export const BulkDeleteConfirmListItem = styled.li`
  margin: 0 0 8px;
  padding: 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DeleteResultsSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 8px;
`;

export const DeleteResultsLabel = styled.div`
  font-size: 13px;
  color: rgb(100, 100, 100);
  font-family: Calibre-Regular, sans-serif;
`;

export const DeleteResultsValue = styled.div`
  font-size: 20px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
`;

export const DeleteResultsFinalSummary = styled.p`
  margin: 0 0 8px;
  font-family: Calibre-Regular, sans-serif;
  font-size: 15px;
  line-height: 1.5;
  color: rgb(26, 23, 28);
`;

export const DeleteResultsSubheading = styled.h4`
  margin: 0 0 8px;
  font-family: Calibre-Semibold, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: rgb(26, 23, 28);
`;

export const DeleteResultsFailedList = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-family: Calibre-Regular, sans-serif;
  font-size: 15px;
  line-height: 1.6;
`;

export const DeleteResultsTableWrap = styled.div`
  margin-top: 8px;
  max-height: 360px;
  overflow: auto;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 8px;
`;

export const DeleteResultsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: Calibre-Regular, sans-serif;
  font-size: 14px;
`;

export const DeleteResultsTh = styled.th`
  text-align: left;
  padding: 10px 12px;
  background: rgb(245, 245, 245);
  color: rgb(26, 23, 28);
  font-family: Calibre-Semibold, sans-serif;
  font-weight: 600;
  border-bottom: 1px solid rgb(224, 224, 224);
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const DeleteResultsTd = styled.td`
  padding: 10px 12px;
  border-bottom: 1px solid rgb(240, 239, 241);
  vertical-align: top;
  color: rgb(26, 23, 28);
  word-break: break-word;
`;

export const DeleteResultsTdMono = styled(DeleteResultsTd)`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
`;

export const DeleteResultsStatusSuccess = styled.span`
  color: rgb(46, 125, 50);
  font-family: Calibre-Semibold, sans-serif;
  font-weight: 600;
`;

export const DeleteResultsStatusFailed = styled.span`
  color: rgb(198, 40, 40);
  font-family: Calibre-Semibold, sans-serif;
  font-weight: 600;
`;
